// src/components/RateLimitWarning.jsx

import React from "react";

const RateLimitWarning = ({ rateLimit, timeUntilReset }) => {
  if (rateLimit.remaining > 100) return null;

  if (rateLimit.remaining === 0) {
    return (
      <div
        className="bg-red-100 text-red-700 p-4 rounded mb-6"
        role="alert"
        aria-live="assertive"
      >
        You have reached the GitHub API rate limit. Please try again in{" "}
        {timeUntilReset || "a few moments"}.
      </div>
    );
  }

  return (
    <div
      className="bg-yellow-100 text-yellow-700 p-4 rounded mb-6"
      role="alert"
      aria-live="polite"
    >
      Warning: You have {rateLimit.remaining} GitHub API requests remaining.
    </div>
  );
};

export default RateLimitWarning;
